import { RightArrow2, LeftArrow } from 'components/Icons/Icons'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useRef } from 'react'
import Link from 'components/Link'
import { heading } from './classes'
import { prepareData } from 'utils/googleData'

const Card = ({ name, url, description, text, text2, Image, ImageSize, color, gatsbyImage, gatsbyImageSrc }) => {
    const sliderImageProps = { quality: 100 }
    return (
        <Link to={url}>
            <li
                style={{ backgroundColor: color || 'white' }}
                className="relative flex h-[400px] w-[300px] flex-shrink-0 snap-center flex-col justify-between overflow-hidden rounded-md p-5 odd:-rotate-3 even:rotate-3 md:first:ml-12"
            >
                <div className={`absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 px-8 ${ImageSize}`}>
                    <GatsbyImage {...sliderImageProps} image={gatsbyImage} />
                </div>
                <h5 className="relative m-0 text-2xl leading-7 text-black">{name}</h5>
                <p className="relative m-0 text-sm text-black">
                    <>
                        {description}{' '}
                        {url != '' && (
                            <Link to={url} className="!text-red">
                                {text}
                            </Link>
                        )}{' '}
                        {text2}
                    </>
                </p>
            </li>
        </Link>
    )
}

export default function CardSlider(props) {
    const listRef = useRef<HTMLUListElement>(null)
    const {
        enable,
        title,
        subtitle,
        homeMarketsTitle,
        description,
        cta,
        markets,
        direction,
        text,
        style,
        gatsbyImage,
        sections,
        gatsbyImage2,
    } = prepareData({ props })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <div dir={direction} className="relative mb-12 overflow-hidden pt-8">
            <h2 className={heading('lg', 'primary', 'mx-auto max-w-[1100px]')}>{homeMarketsTitle?.title}</h2>
            <h3 className="mt-4 text-center text-lg md:mt-8 md:px-8 md:text-2xl">
                {homeMarketsTitle?.subtitle}
                <br />
            </h3>
            <div className="bg-gradient-radial absolute -left-10 top-64 bottom-32 z-10 w-48 from-light/30 via-light/0 to-light/0 dark:from-dark/30 dark:via-dark/0 dark:to-dark/0" />
            <div className="absolute top-1/2 left-0 z-20 mt-16 -translate-y-1/2">
                <button
                    onClick={() => listRef?.current?.scrollBy({ left: -300, behavior: 'smooth' })}
                    className="relative p-8 hover:top-[-1px] hover:scale-[1.01] active:top-[.5px] active:scale-[.99] md:z-30"
                >
                    <LeftArrow className="w-10 dark:bg-red" />
                </button>
            </div>
            <ul
                ref={listRef}
                className="m-0 flex w-full snap-x list-none space-x-12 overflow-x-auto overflow-y-hidden p-0 px-5 py-6 lg:py-12"
            >
                {markets?.length > 0 &&
                    markets.map((market, index) => {
                        return <Card {...market} key={index} />
                    })}
            </ul>
            <div className="bg-gradient-radial absolute -right-10 top-64 bottom-32 w-48 from-light/30 via-light/0 to-light/0 dark:from-dark/30 dark:via-dark/0 dark:to-dark/0" />
            <div className="absolute top-1/2 right-0 mt-16 -translate-y-1/2">
                <button
                    onClick={() => listRef?.current?.scrollBy({ left: 300, behavior: 'smooth' })}
                    className="relative p-8 hover:top-[-1px] hover:scale-[1.01] active:top-[.5px] active:scale-[.99] md:z-30"
                >
                    <RightArrow2 className="w-10 dark:bg-red" />
                </button>
            </div>
        </div>
    )
}
